<template>
  <ion-app>
    <router-view></router-view>
  </ion-app>
</template>

<script>

export default {
  name: "app",
  created() {
    // Écoute l'événement 'newServiceWorker'
    window.addEventListener('newServiceWorker', this.updateReady);
  },
  methods: {
    updateReady() {
      this.$bvToast.toast('Nouvelle version de l\'application disponible. Rafraîchissement...', {
        title: `Mis à jour`,
        solid: true,
        toaster:'b-toaster-top-center'
      });

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    },
  },
  mixins: [],
};
</script>
